var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-sm btn-dual ml-auto",attrs:{"href":"javascript:void"},on:{"click":_vm.showcart}},[_c('i',{staticClass:"fas fa-shopping-basket"}),_vm._v("\n  "+_vm._s(_vm._f("currency")(!_vm.$_.isEmpty(_vm.cart) ? _vm.cart.total_excl_with_discount_and_promocodes : 0))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }